package team.platforma.multiplatform_material_extension.ui

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.text.intl.Locale
import androidx.compose.ui.text.intl.LocaleList
import androidx.compose.ui.unit.dp
import materialextension.multiplatform_material_extension.generated.resources.Res
import materialextension.multiplatform_material_extension.generated.resources.mel_hide_password
import materialextension.multiplatform_material_extension.generated.resources.mel_show_password
import org.jetbrains.compose.resources.painterResource
import team.platforma.multiplatform_material_extension.model.RequiredField
import team.platforma.multiplatform_material_extension.util.FormValidator
import team.platforma.multiplatform_material_extension.util.isEnabled
import team.platforma.multiplatform_material_extension.util.rememberStringValidator

@Deprecated("Устаревшая реализация")
@Composable
fun OutlinePasswordInputField(
    modifier: Modifier = Modifier,
    value: String,
    onPasswordChanged: (String) -> Unit,
    validateRegex: Regex = Regex("^[a-zA-Z0-9!@#$%^&*(),.?\":{}|<>_\\-+=/\\\\~`]*$"),
    validate: (Boolean) -> Unit = {},
    formValidator: FormValidator? = null,
    formKey: String? = null,
    requiredField: RequiredField,
    helpMessage: String,
    errorMessage: String,
    minSymbols: Int = 6,
    enabled: Boolean = true,
    keyboardOptions: KeyboardOptions = KeyboardOptions.Default.copy(
        keyboardType = KeyboardType.Password,
        hintLocales = LocaleList(Locale("en"))
    )
) {
    var password by remember { mutableStateOf(value) }
    var hidePassword by remember { mutableStateOf(true) }
    var validatePasswordResult by remember { mutableStateOf(false) }

    var userInput by remember { mutableStateOf(false) }
    var errorInput by remember { mutableStateOf(false) }

    val fieldValidator = rememberStringValidator()

    LaunchedEffect(Unit) {
        validatePasswordResult = fieldValidator.createValidateStringResult(
            requiredField.boolean,
            password,
            validateRegex
        )
        val passwordLength = password.length
        val resultValidation = validatePasswordResult && passwordLength >= minSymbols

        formKey?.let { key ->
            formValidator?.let {
                it.setValidateState(key, resultValidation)
                it.initFormString(key, password)
                it.changeFormString(key, password)
            }
        }

        validate(resultValidation)

        onPasswordChanged(password)
    }

    when (formValidator?.isEnabled()?: enabled) {
        true -> {}
        false -> {
            hidePassword = true
        }
    }

    Column(
        modifier = modifier
    ) {
        OutlinedTextField(
            modifier = Modifier
                .fillMaxWidth()
                .onFocusChanged {

                },
            value = password,
            onValueChange = {
                userInput = true
                password = it
                validatePasswordResult = fieldValidator.createValidateStringResult(
                    requiredField.boolean,
                    password,
                    validateRegex
                )

                val resultValidation = fieldValidator.createResultValidation(requiredField.boolean, validatePasswordResult, password, minSymbols)

                formKey?.let { key ->
                    formValidator?.let { validator ->
                        validator.setValidateState(key, resultValidation)
                        validator.changeFormString(key, password)
                    }
                }

                validate(resultValidation)
                onPasswordChanged(password)
            },
            label = { Text("Пароль") },
            visualTransformation = if (hidePassword) PasswordVisualTransformation() else VisualTransformation.None,
            trailingIcon = {
                Icon(
                    painter = painterResource(if (hidePassword) Res.drawable.mel_hide_password else Res.drawable.mel_show_password),
                    contentDescription = null,
                    modifier = Modifier.size(40.dp)
                        .clip(CircleShape)
                        .clickable(
                            enabled = formValidator?.isEnabled() ?: enabled
                        ) { hidePassword = !hidePassword }
                )
            },
            keyboardOptions = keyboardOptions,
            isError = errorInput,
            enabled = formValidator?.isEnabled() ?: enabled
        )
        AnimatedVisibility(
            fieldValidator.showMessage(
                userInput,
                validatePasswordResult,
                requiredField.boolean,
                password,
                minSymbols
            )
        ) {

            errorInput = fieldValidator.isErrorInput(
                userInput,
                validatePasswordResult,
                requiredField.boolean,
                password,
            )

            AnimatedContent(
                targetState = errorInput,
                transitionSpec = {
                    (fadeIn() + slideInVertically()).togetherWith(fadeOut() + slideOutVertically())
                }
            ) { isError ->
                Text(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp),
                    text = if (isError) {
                        if (requiredField.boolean && password.isEmpty()) {
                            requiredField.message
                        } else {
                            errorMessage
                        }

                    } else {
                        helpMessage

                    },
                    color = if (isError) MaterialTheme.colorScheme.error else MaterialTheme.colorScheme.onSurface
                )


            }
        }
    }
}